module.exports = __webpack_public_path__ + "static/media/access-security.2b817642.svg";